import { computed } from 'vue'
import { DateTime } from 'luxon'
import { useNow } from '@/composables/game/time'

/** Dropee x Kokomo campaign hub, opened from the home screen bottom buttons. */
export const KOKOMO_LINK = 'https://dropee.kokomo.games'

/** The campaign ends with the month, at the end of 2026-10-31 UTC. */
const KOKOMO_END_TIMESTAMP = DateTime.fromISO('2026-11-01T00:00', { zone: 'utc' }).toUnixInteger()

export const useKokomo = () => {
  const { now } = useNow()

  const countdownForKokomoEnd = computed(() => Math.max(0, KOKOMO_END_TIMESTAMP - now.value))

  // The button goes away once the campaign is over.
  const showKokomo = computed(() => countdownForKokomoEnd.value > 0)

  return {
    showKokomo,
    countdownForKokomoEnd,
  }
}
